// src/components/activity/AiContainer.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingBouncyDots from "../ui/LoadingBouncyDots";

/**
 * AiContainer
 * - Wraps AI coach copy + loading/error state
 */
export function AiContainer({
  title = "CoachUltra",
  children,
  className = "",
  advice,
  loading = false,
  err,
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className={`w-full !h-fit ai-container ${className}`}>
      <div className="flex flex-row gap-1 items-center justify-start w-full">
        <h3 className="subtitle-text text-primary">{title}</h3>
      </div>

      {/* While generating – always show dots */}
      {loading && (
        <LoadingBouncyDots
          text=""
          className="min-h-12 items-center justify-center"
        />
      )}

      {/* Only render children when not loading */}
      {!loading && children}

      {/* Initial empty state: no advice yet, no error, not loading */}
      {!loading && !advice && !err && (
        <LoadingBouncyDots
          text=""
          className="min-h-12 items-center justify-center"
        />
      )}

      {err && <p className="mt-2 text-sm text-red-600">{err}</p>}
    </div>
  );
}
